module.exports = __webpack_public_path__ + "static/media/inf_94og95.fa234a84.mp3";